import { useCallback, useEffect } from 'react';

import { History } from 'history';

import { Logger } from 'src/common/services/Logger';

import { navigateToFirstBusinessUnit } from '../helpers/NavigationHelpers';
import { BusinessUnit } from '../types/DashboardTypes';

import { useDashboardBasePath } from './useDashboardBasePath';

interface UseBusinessUnitRedirectParams {
	unitId: string | undefined;
	businessUnits: BusinessUnit[];
	history: History;
}

export const useBusinessUnitRedirect = ({
	unitId,
	businessUnits,
	history
}: UseBusinessUnitRedirectParams): void => {
	const basePath = useDashboardBasePath();

	const redirectToFirstUnit = useCallback(() => {
		if (businessUnits.length > 0) {
			try {
				navigateToFirstBusinessUnit(history, businessUnits, basePath);
			} catch (error) {
				Logger.error('Failed to redirect to first business unit:', error);
			}
		}
	}, [history, businessUnits, basePath]);

	useEffect(() => {
		// Only redirect if we don't have a unitId and business units are loaded
		if (!unitId && businessUnits.length > 0) {
			redirectToFirstUnit();
		}
	}, [unitId, businessUnits.length, redirectToFirstUnit]);
};
